import { Text } from '../../..'
import useViewport from '../../../../hooks/useViewport'
import { ListingDetailsListing } from '../../../../types/listings'
import { useFormattedListingAddress } from '../../../../hooks/listings'

export interface AddressSectionProps {
  className?: string
  listing: ListingDetailsListing
}

export const AddressSection = ({ listing, className }: AddressSectionProps) => {
  const { isMedium } = useViewport()
  const addressObject = useFormattedListingAddress(listing)

  const align = isMedium ? 'center' : 'left'

  return (
    <div className={className}>
      <Text
        weight='bold'
        align={align}
        variantCount='900'
        variant='neutralCool'
        size={isMedium ? 's' : 'xl'}
      >
        {addressObject.firstLineAddress}
      </Text>
      <Text variant='neutralCool' variantCount='700' size='s' align={align}>
        {addressObject.secondLineAddress}
      </Text>
    </div>
  )
}
